<template>
    <div class="container header-margin">
        
        <div class="text-center p-2 text-color text-area">
            <h2 class="main_title">{{ $t('auth.signupTitleAube') }}</h2>
        </div>

        <div class="tab-content p-2">
            <div class="row no-gutters text-center navigation">
                <div id="box1" class="col-md-3 col-sm-3 col-xs-5 box-area active-color-box"><p class="text-center">{{ $t('auth.navigationAube.title1') }}</p></div>
                <div id="box2" class="col-md-3 col-sm-3 col-xs-5 box-area non-active-color-box"><p class="text-center">{{ $t('auth.navigationAube.title2') }}</p></div>
                <div id="box3" class="col-md-3 col-sm-3 col-xs-5 box-area non-active-color-box"><p class="text-center">{{ $t('auth.navigationAube.title3') }}</p></div>
                <div id="box4" class="col-md-3 col-sm-3 col-xs-5 box-area non-active-color-box"><p class="text-center">{{ $t('auth.navigationAube.title4') }}</p></div>
            </div>

            <div class="text-center p-2 text text-color text-area">
                <h3 class="sub_title">{{ $t('auth.signupMailAube') }}</h3>
            </div>

            <form @submit.prevent="handleOnSubmit" class="wrap-padding">
                <div class="text-area">
                    <p class="pre">{{ $t('createUserMessage.pleaseAube') }}</p>
                </div>

                <div class="form-group row">
                    <label style="width:180px; margin-left:17px;" for="account" class="pre">{{ $t('account.emailAube') }}</label>
                    <div class="col-sm-8">
                        <input v-model="formData.account" type="text" id="account" name="account"
                        class="form-control"
                        v-bind:class="{ 'is-invalid': errors.account}"/>
                        <div v-if="errors.account" class="invalid-feedback invalid-errors">{{ $t('errors.' + errors.account) }}</div>
                    </div>
                    <div v-if="(!errors.account)" class="invalid-errors-hiddens"></div>
                </div>

                <div class="form-group row">
                    <label style="width:180px; margin-left:17px;" class="form-check-label tosAgreeForm pre" v-html="$t('account.email_confirmationAube')" for="tosAgree">
                    </label>                        
                    <div class="col-sm-8">
                        <input v-model="formData.account_confirmation" type="text" id="account_confirmation" name="account_confirmation"
                        class="form-control"
                        v-bind:class="{ 'is-invalid': errors.account_confirmation}"/>
                        <div v-if="errors.account_confirmation" class="invalid-feedback invalid-errors">{{ $t('errors.' + errors.account_confirmation) }}</div>
                    </div>
                    <div v-if="(!errors.account_confirmation)" class="invalid-errors-hiddens"></div>
                </div>

                <div class="text-center mt-4">
                    <div class="form-check">
                        <input v-model="formData.tosAgree" name="tosAgree" type="checkbox"
                            class="form-check-input tosAgreeForm" id="tosAgree"
                            v-bind:class="{ 'is-invalid': errors.tosAgree}">
                        <label class="form-check-label tosAgreeForm" v-html="$t('auth.agreeLabelAube')" for="tosAgree">
                        </label>
                        <div v-if="errors.tosAgree" class="invalid-feedback invalid-tosAgree" style="margin-left:11px">{{ $t('errors.' + errors.tosAgree) }}</div>
                    </div>
                    <div v-if="(!errors.tosAgree)" class="invalid-tosAgree-hiddens"></div>
                    
                    <div>
                        <button type="submit" class="btn btn-primary" :disabled="submitBtnDisabled()">{{ $t('auth.confirmBtn') }}</button>
                    </div>
                    <div style="margin-top: 20px;">
                        <label class="form-check-label tosAgreeForm pre" v-html="$t('auth.pleaseLoginAube')"></label>
                    </div>
                </div>
            </form>
        </div>
    </div>

</template>

<script>
    import UserService from '../../../services/UserService';
    import languageService from "../../../services/LanguageService";

    export default {
        name: 'login-module',

        mounted() {
            this.maxHeight();
        },

        data() {
            return {
                errors: this.getDefaultFields(),
                formData: this.getDefaultFields(),
                mailData: this.getDefaultFields(),
                submitted: false,
                isLoaded: false,
            }
        },
        methods: {
            getDefaultFields() {
                return {
                    account: '',
                    account_confirmation: '',
                    tosAgree: false,
                };
            },

            submitBtnDisabled() {
                return this.submitted;
            },

            openTermsWindow() {
                let r = this.$router.resolve({ name: 'terms' });
                if (r && r.href) {
                    window.open(r.href, '_blank');
                }
            },

            windowClose() {
                window.close();
            },

            async handleOnSubmit() {
                this.errors = this.getDefaultFields();

                try {
                    this.submitted = true;
                    let languageCode = await languageService.getCurrentLanguageCode();
                    await UserService.createUserAube({
                        ...this.formData,
                        tosAgree: this.formData.tosAgree === true ? true : null,
                        languageCode: languageCode,
                    });
                    sessionStorage.mailData = JSON.stringify(this.formData)
                    this.$router.push('/registration/check-email');
                } catch (err) {
                    if (err.response.data.errors) {
                        err.response.data.errors.forEach(errItem => {
                            if (errItem.field) {
                                if (typeof(errItem.field) === 'string') {
                                    this.errors[errItem.field] = errItem.message[0];
                                } else {
                                    for(let field in errItem.field) {
                                        if (errItem.field.hasOwnProperty(field)) {
                                            this.errors[errItem.field[field]] = errItem.message[0];
                                        }
                                    }
                                }
                            }
                        })
                    }
                } finally {
                    this.submitted = false;
                }
            },

            async maxHeight() {
                setTimeout(() => {
                    this.display = true
                    let box1 = document.getElementById('box1').clientHeight
                    let box2 = document.getElementById('box2').clientHeight
                    let box3 = document.getElementById('box3').clientHeight
                    let box4 = document.getElementById('box4').clientHeight
                    let maxHeight = Math.max(box1,box2,box3,box4);
                    document.getElementById('box1').style.height = maxHeight+'px'
                    document.getElementById('box2').style.height = maxHeight+'px'
                    document.getElementById('box3').style.height = maxHeight+'px'
                    document.getElementById('box4').style.height = maxHeight+'px'
                 }, 1000);
            },     
        }
    }
</script>

<style scoped>
    .main_title{
        margin-bottom: 30px;
    }
    .sub_title{
        margin-bottom: 15px;
    }
    .tos.form-control:disabled {
        background-color: white;
    }
    .tosAgreeForm {
        cursor: pointer;
    }
    .pre {
        white-space: pre-wrap;
    }
    .text-color{
        color: #451493;
    }
    .active-color-box{
        background: #451493;
        border-color:#451493;
    }
    .non-active-color-box{
        background: #bdbebd; 
    }
    .text{
        font-size: 25px;
    }
    .navigation{
        padding-bottom:40px;
    }
    .text-area{
        padding-bottom: 20px;
    }
    .box-area {
        padding: 0.5em 0em;
        width:50%;
        color: #FFF;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    #box2,#box3,#box4{
        outline: 1px solid #FFF;
    }
    .text-box{
        display: block;
    }
    .box-area p {
        margin-top: 2px;
        margin-bottom: 2px;
        padding-top: 1px;
    }
    .btn-primary{
        width: 115px;
        margin-top: 10px;
    }
    /*ボタンのスタイル*/
    .btn-primary:hover {
        color: #fff !important;
        background-color: #350f71 !important;
        border-color: #300e66 !important;
    }
    /*PC PAD用css*/
    @media screen and (min-width: 479px) {
        .invalid-errors-hiddens{
            visibility:hidden;
            height: 77px;
            margin-top: 4px;
            margin-bottom: 4px;
        }
        .invalid-errors{
            min-height:40px;
            height:auto !important;
            height:40px;
            margin-top: 4px;
            margin-bottom: 4px;
        }
        .invalid-tosAgree-hiddens{
            visibility:hidden;
            height: 11px;
            margin-top: 5px;
            margin-bottom: 4px;
        }
        .invalid-tosAgree{
            min-height:10px;
            height:auto !important;
            height:10px;
            margin-top: 3px;
        }
    }
    /*スマホ用css*/
    @media screen and (max-width: 479px) { 
        .invalid-errors-hiddens{
            visibility:hidden;
            height: 51px;
            margin-top: 4px;
            margin-bottom: 9px;
        }
        .invalid-errors{
            min-height:18px;
            height:auto !important;
            height:18px;
            margin-top: 4px;
            margin-bottom: 5px;
        }
        .invalid-tosAgree-hiddens{
            visibility:hidden;
            height: 13px;
            margin-top: 4px;
            margin-bottom: 4px;
        }
        .invalid-tosAgree{
            min-height:10px;
            height:auto !important;
            height:10px;
            margin-top: 4px;
        }
        .form-group {
            margin-bottom: 0px;
        }
        .header-margin{
            padding-left: 0px;
            padding-right: 0px;
        }
        .main_title{
            margin-bottom: 0px;
            font-size: 1.575rem;
        }
        .sub_title{
            margin-bottom: 0px;
            font-size: 1.3rem;
        }
        .navigation{
            padding-bottom:15px;
        }

    }
    @media screen and (min-width: 991px) {
        .wrap-padding{
            padding-left:29px;
        }
    }
    @media screen and (max-width: 991px) { 
        .wrap-padding{
            padding-left:12px;
        }
    }
    
</style>
